<div class="mpc-dialog-body">
  <h3 class="dialog-title">Create MountPoint Connection</h3>

  <div class="mb-3">
    <label class="form-label">Mount Point</label>
    <input class="form-control" [(ngModel)]="mount_point" required placeholder="Enter mount point">
    <div class="text-danger small" *ngIf="!mount_point">Required</div>
  </div>

  <div class="mb-3">
    <label class="form-label">Server</label>
    <input class="form-control" [(ngModel)]="server" required placeholder="Enter server hostname/IP">
    <div class="text-danger small" *ngIf="!server">Required</div>
  </div>

  <div class="mb-3">
    <label class="form-label">Port</label>
    <input class="form-control" [(ngModel)]="port" required placeholder="Enter port">
    <div class="text-danger small" *ngIf="!port">Required</div>
    <div class="text-danger small" *ngIf="port && port.trim() && !isPortNumeric(port)">Must be numeric (1-65535)</div>
  </div>

  <div class="mb-3">
    <label class="form-label">Downloader User Name</label>
    <input class="form-control" [(ngModel)]="d_user_name" required placeholder="Enter downloader user">
    <div class="text-danger small" *ngIf="!d_user_name">Required</div>
  </div>

  <div class="mb-3">
    <label class="form-label">Downloader Password</label>
    <input class="form-control" [(ngModel)]="d_password" required placeholder="Enter downloader password">
    <div class="text-danger small" *ngIf="!d_password">Required</div>
  </div>

  <div class="text-end pt-2">
    <button class="btn btn-outline-secondary me-2" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary"
            [disabled]="!mount_point || !server || !port || !isPortNumeric(port) || !d_user_name || !d_password"
            (click)="create()">Create</button>
  </div>
</div>


